import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import clsx from 'clsx'
// import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { getComponentHeights } from '../utils'
import { AgentChatDataSchema, AgentChatUISchema } from './types'
import { EmbeddedAiChat } from '../../AppSupportMenuAiChat/AppSupportMenuAiChat'

export function AgentChatContent({
  uiSchema,
  dataSchema,
  tileFilters,
}: {
  uiSchema: AgentChatUISchema
  dataSchema: AgentChatDataSchema
  tileFilters?: React.ReactNode
}) {
  const { title = undefined, description = undefined, emphasizeHeader } = uiSchema
  const hasHeader = !!title && !!tileFilters
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)
  const { agentKey } = dataSchema
  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader>
          <ComponentTitle title={title} description={description} />
          {tileFilters}
        </ComponentHeader>
      )}
      <div className={clsx({ 'pt-5': hasHeader })} style={{ height: contentHeight }}>
        <EmbeddedAiChat agentKey={agentKey} />
      </div>
    </div>
  )
}
